var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_32",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3003",
    "data-name": "Group 3003",
    transform: "translate(-71 -4613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237",
    transform: "translate(-46 1402)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 117, 3211)",
    filter: "url(#Ellipse_32)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32-2",
    "data-name": "Ellipse 32",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(9 9)",
    fill: "#ed1c24"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M12.731,0a.554.554,0,0,0-.392.162L.155,12.345a.554.554,0,0,0,.783.783L12.731,1.337,24.523,13.129a.554.554,0,0,0,.783-.783L13.122.163A.554.554,0,0,0,12.731,0Z",
    transform: "translate(145.19 3262.093) rotate(-90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBackArrow);
export default __webpack_public_path__ + "static/media/redBackArrow.fc82b621d4bc7b795a6af023d81ffc00.svg";
export { ForwardRef as ReactComponent };